import { memo } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { Illustration } from '@mint-lib/illustrations';
import styled from '@mint-lib/styled';

export type Props = {
  noFoundContent?: boolean;
  search?: string;
};

const Co2NoContent = ({ noFoundContent = false, search }: Props) => {
  const { t } = useTranslation('@myn/planning');

  const noResults = search
    ? t('No results for {{search}}', { search })
    : t('No results');

  return (
    <Wrapper>
      <IllustrationWrapper>
        <Illustration
          component={
            noFoundContent ? 'IllustrationNoResults' : 'IllustrationEmptyState'
          }
        />
      </IllustrationWrapper>
      <TitleWrapper>
        {noFoundContent
          ? noResults
          : t("You don't have any notifications for Carbon Offset")}
      </TitleWrapper>

      {!noFoundContent && (
        <SubTitleWrapper>
          {t(
            'If the Carbon Offset feature is active, you will receive a notification at the end of each buying plan.',
          )}
        </SubTitleWrapper>
      )}
    </Wrapper>
  );
};

const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.ui.primary};

  width: 100%;
  height: 100%;
  border-radius: 6px;
  color: ${({ theme }) => theme.palette.text.primary};
`;

const IllustrationWrapper = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 160px;
  height: 160px;
  background-color: ${({ theme }) => theme.palette.ui.primary};
  border-radius: 6px;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  margin-top: ${({ theme }) => theme.spacing(12.5)};
`;
const TitleWrapper = styled('div')`
  max-width: 552px;
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  text-align: center;
`;

const SubTitleWrapper = styled('div')`
  max-width: 479px;
  width: 100%;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
`;

export default memo(Co2NoContent);
